export { partnershipEmails } from '../en/partnership-emails';
